import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { CommentsDataService, CommentsColumnsService } from '../../../services';
import { Comment, CommentsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-comment-details',
  templateUrl: './comment-details.component.html',
  styleUrls: ['./comment-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class CommentDetailsComponent implements OnInit, OnDestroy {

  public comment: Comment = {};
  public comments: Comment[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private commentsDataService: CommentsDataService,
    private commentsColumnsService: CommentsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Comment - Details');
        this.getComment(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.comment !== 'undefined') {
      this.comment = this.dynamicDialogConfig.data.comment;
    }
    this.columns = this.commentsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getComment(id: number): void {
    this.isLoading = true;
    this.commentsDataService.getComment(id).subscribe((response: Comment|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.comment = response;
      }
    });
  }

  list() {
    this.router.navigate(['/comments']);
  }

  add() {
    this.router.navigate(['/comments/add']);
  }

  edit() {
    this.router.navigate(['/comments/edit/' + this.comment.id]);
  }

}
@Component({
  selector: 'app-comment-details',
  templateUrl: './comment-details.component.html',
  styleUrls: ['./comment-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCommentDetailsComponent extends CommentDetailsComponent {
}

